import React from 'react'
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import Header from './components/Header'
import Pakistan from './components/Pakistan';
import Punjab from './components/Punjab';
import Karachi from './components/Karachi';
import Khyber from './components/Khyber';
import Balochistan from './components/Balochistan';
import Provinces from './components/Provinces';
import Form from './components/Form';
import Footer from './components/Footer';
import {Route,Routes} from "react-router-dom";
const App = () => {
  return (
    <>
    <Header/>
    <Pakistan
    heading="Pakistan"
    button="Pakistan Provinces" />
    <Form/>
    <Footer/>
    <Routes>
      <Route exact path="/" component={Pakistan} />
      <Route exact path="/punjab" component={Punjab} />
      <Route exact path="/karachi" component={Karachi} />
      <Route exact path="/khybar" component={Khyber} />
      <Route exact path="/balochistan" component={Balochistan} />
    </Routes>
    </>
  )
}

export default App